import styles from './heroBanner.module.css';
import { Carousel } from 'react-responsive-carousel';
import { useEffect, useState } from 'react';

function HeroBanner({ category = null, list = null, onImagesLoaded = null }) {
    const [images, setImages] = useState([]);

    useEffect(() => {
        async function fetchImages() {
            if (category) {
                try {
                    const response = await fetch(`/api/herobanner/${category}`);
                    if (!response.ok) throw new Error("Failed to fetch");
                    const data = await response.json();
                    setImages(data);
                    if (onImagesLoaded) {
                        onImagesLoaded(data.length > 0);  // <-- use data.length here
                    }
                } catch (error) {
                    console.error("Error loading hero banner images:", error);
                }
            } else if (list) {
                setImages(list);
            }
        }

        fetchImages();
    }, [category, list]);

    function mapImagePos(pos) {
        switch (pos) {
            case 'top': return 'center top';
            case 'bottom': return 'center bottom';
            default: return 'center center'; // center or fallback
        }
    }

    if (!images.length) return null;


    return (
        <div className={styles.container}>
            <Carousel
                className={styles.carousel}
                showArrows={false}
                autoPlay
                infiniteLoop
                stopOnHover
                swipeable
                showThumbs={false}
                showIndicators={false}
                interval={11500}
                transitionTime={1500}
                showStatus={false}
            >
                {images.map((img, index) => (
                    <img key={index} className={styles.imgSingle} src={img.path} alt={img.alt}
                        style={{ objectPosition: mapImagePos(img.image_pos) }} />
                ))}
            </Carousel>
        </div>
    );
}

export default HeroBanner;
